<template>
  <pt-qr-code-table ref="table" class="pt-qr-code-table__withData" @getTableData="getTableData" :totalNumber="totalNumber" :tableData="tableData"
  :tableLabels="tableLabels" v-loading="loading">
      <slot/>
  </pt-qr-code-table>
</template>

<script>
import PtQrCodeTable from './index'
export default {
  name: 'pt-qr-code-table__withData',
  components: {
    'pt-qr-code-table': PtQrCodeTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      loading: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.$refs.table.resetPage()
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: this.page,
          size: this.pageSize
        }
      }
      if (!next) {
        this.loading = false
      }
      this.$store.dispatch('getQrCodeList', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.$message.error(err || '获取商品二维码列表失败')
        this.loading = false
      })
    }
  }
}
</script>
